import { X } from "lucide-react";
import { useState } from "react";
import { useIntercom } from "react-use-intercom";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { StepComponentProps } from "../step-config-file/types";

interface InfoCardData {
  title: string;
  copy: string | React.ReactNode;
  showExploreButton?: boolean;
  showSpeakToExpertButton?: boolean;
}

export const InfoCard = (props: StepComponentProps) => {
  const { showNewMessage } = useIntercom();
  const cardData = props.data as InfoCardData;
  const [isTransitioning, setIsTransitioning] = useState(false);

  const handleExit = () => {
    const exploreStepId = 11;
    const currentStepId = props.id;

    if (currentStepId < exploreStepId) {
      setIsTransitioning(true);

      props.moveToNextLocation({
        longitude: 146.16271,
        latitude: -18.65488,
        geocoder_attributes: {},
        zoomLevel: 13,
        targetStep: exploreStepId,
      });

      setTimeout(() => {
        props.goToStep(exploreStepId);
      }, 2500);
    }
  };

  const handleNext = () => {
    if (props.nextCoordinates && props.zoomLevel) {
      props.moveToNextLocation({
        ...props.nextCoordinates,
        geocoder_attributes: {},
        zoomLevel: props.zoomLevel,
        targetStep: props.id + 1,
      });
    }
    props.nextStep();
  };

  const handleBack = () => {
    if (props.previousCoordinates && props.previousZoomLevel) {
      props.moveToNextLocation({
        ...props.previousCoordinates,
        geocoder_attributes: {},
        zoomLevel: props.previousZoomLevel,
        targetStep: props.id - 1,
      });
    }
    props.backStep();
  };

  const handleSpeakToExpert = () => {
    showNewMessage(
      "I'd like to learn more about First Floor Elevation Insights",
    );
  };

  if (isTransitioning) {
    return null;
  }

  return (
    <Card className="fixed bottom-25 left-[35%] z-1000 flex w-140 max-w-full flex-col self-end rounded-2xl">
      <CardHeader className="flex flex-row items-center justify-between">
        <CardTitle className="text-xl">{cardData.title}</CardTitle>
        <Button
          variant="ghost"
          size="icon"
          aria-label="close"
          onClick={handleExit}
          className="size-7"
        >
          <X className="size-4" />
        </Button>
      </CardHeader>
      <CardContent className="space-y-2 p-4 text-sm">
        {typeof cardData.copy === "string" ? <p>{cardData.copy}</p> : cardData.copy}
      </CardContent>
      <CardFooter className="justify-between p-2">
        {props.id === 1 ? (
          <Button variant="ghost" size="sm" onClick={handleExit}>
            Exit
          </Button>
        ) : props.id > 1 ? (
          <Button variant="ghost" size="sm" onClick={handleBack}>
            Back
          </Button>
        ) : null}
        {cardData.showSpeakToExpertButton && (
          <Button size="sm" onClick={handleSpeakToExpert}>
            SPEAK TO AN EXPERT
          </Button>
        )}
        {cardData.showExploreButton ? (
          <Button size="sm" onClick={handleNext}>
            Explore
          </Button>
        ) : (
          <Button size="sm" onClick={handleNext}>
            Next
          </Button>
        )}
      </CardFooter>
    </Card>
  );
};
